export default (props) => (
  <svg {...props} width="24" height="24" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      d="M5.786 0 1.5 4.286v15.429h5.143V24l4.286-4.286h3.429L21.429 12V0H5.786zm14.571 11.143-3.429 3.429h-2.286l-3 3v-3H6.643V1.714h13.714v9.429z"
    />
    <path
      fill="currentColor"
      d="M17.786 4.714h-1.714V9h1.714V4.714zm-4.286 0h-1.714V9h1.714V4.714z"
    />
  </svg>
);
